import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IdentificateService } from "../../service/identificate.service";
import { Location } from '@angular/common';
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { AuthWatabilightService } from "../../service/authWatabilight.service";
import { BookingService } from "../../service/booking.service";
import { Yii } from "libraries/interfaces/Yii";
import { INotification } from "libraries/interfaces/INotification";

@Component({
    selector: 'identification-watabi-light',
    templateUrl: './identification.component.html',
    styleUrls: [
        './identification.component.scss'
    ]
})
export class IdentificationComponent implements OnInit, OnDestroy {
    public wui_url: string = `${sessionStorage.getItem("$wui_url")}`;
    public notification: INotification = {active: false, message: ""};
    public loader: boolean = false;

    // TODO utiliser yii
    public loaderMsg: string = Yii.t('wui-shared-js', 'Chargement de la page');

    private booking_Id: string;
    private booking_Idv: string;
    private paramSub: Subscription;

    constructor(
        private identificateService: IdentificateService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private bookingService: BookingService,
        private readonly authWatabilightService: AuthWatabilightService,
    ) {
    }

    public ngOnInit(): void {
        this.loader = true;
        this.paramSub = this.route.params.subscribe(params => {
            this.booking_Id = params.id;
            this.booking_Idv = params.idv;

            const url_to_decode: string = window.location.origin + this.wui_url.slice(0, -1) + this.router.url.slice(0, -1);

            this.identificateService.identificate(url_to_decode, this.booking_Id, this.booking_Idv)
                .pipe(
                    map((response: any) => response.data))
                .subscribe((val: any) => {
                        this.loader = false;
                        if (val.data.isValid) {
                            this.bookingService.setBookingId(this.booking_Id);
                            this.bookingService.setBookingIdVersion(this.booking_Idv);
                            this.bookingService.setWatabihash(this.router.url.slice(this.router.url.indexOf("?") + 1, -1));
                            this.authWatabilightService.watabiLogin();
                            this.authWatabilightService.getXsecurity();
                        } else {
                            this.notification = {active: true, message: val.message};
                        }
                    },
                    (): any => {
                        this.loader = false;
                        this.notification = {active: true, message: Yii.t("wui-shared-js","Internal Serveur Erreur")};
                    });
        });
    }

    public ngOnDestroy(): void {
        this.paramSub.unsubscribe();
    }

}
